import { formatMoneyShort } from "@/lib/money"

// Actual so far against the node's year target: a soft fill, then how much is
// left (or how far over) in words.
export default function YearTargetBar({ actual, target, currency }: { actual: number; target: number; currency: string | null }) {
  const share = target > 0 ? Math.min(actual / target, 1) : 0
  const left = target - actual
  return (
    <div className="flex items-center gap-2" title={`${formatMoneyShort(actual, currency)} of ${formatMoneyShort(target, currency)}`}>
      <span className="w-14 shrink-0 text-right">{formatMoneyShort(target, currency)}</span>
      <span className="block h-1.5 w-24 shrink-0 overflow-hidden rounded-full" style={{ background: "color-mix(in srgb, var(--foreground) 8%, transparent)" }}>
        <span
          className="block h-full rounded-full"
          style={{
            width: `${share * 100}%`,
            background: left <= 0
              ? "color-mix(in srgb, var(--success) 55%, transparent)"
              : "color-mix(in srgb, var(--primary) 40%, transparent)",
          }}
        />
      </span>
      <span className="w-24 shrink-0 text-left">
        {left > 0 ? `${formatMoneyShort(left, currency)} left` : (
          <span style={{ color: "var(--success)" }}>+{formatMoneyShort(-left, currency)} over</span>
        )}
      </span>
    </div>
  )
}
